var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sm-select-modal"},[_c('div',{staticClass:"sm-select-modal-content"},[_c(_vm.view,{tag:"component",on:{"change-model":_vm.changeModel,"back-to-model-list":_vm.backToModelList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }